function removerow(idvalue, filename, uid) {
	var temp = idvalue.toString();
	var targetrow = [];
	targetrow.push(parseInt(idvalue));
	// console.log(targetrow);
	$.ajax({
		method: "post",
		url: "php/deleteinput.php",
		data: {
			jobId: uid,
			fileName: filename
		},
		// async: false,
		success: function (r1, r2, r3) {
			//console.log(r1);
			$("#modeltable").bootstrapTable("remove", {field: 'fileid', values: targetrow});
		},
		error: function (r1) {
			console.error("Fail to get example:", r1);
			alert("Delete failed: " + r1);
			//return "fail";
		}

	});
}

export function ModelTable(data, uid){
	// console.log(data);
	//$("#result").append("<table class='table-condensed table table-hover' id='stb' border='1'cellspacing='0' bordercolor='#cccccc'></table>");
	$("#modeltable").bootstrapTable("destroy");	
	$("#modeltable").bootstrapTable(		
		{
		//method: 'get',		
		data:data,		
		//detailView: true,
		pagination: true,
		pageSize: 5,
		//pageList: [10,25,50,100],
		striped: true,
		search: true,
		columns:[
			{					
				field:'fileid',
				title:'File ID',
				align: 'center',
				valign: 'middle'
			},
			{					
				field:'filename',
				title:'File Name',
				align: 'center',
				valign: 'middle',
				formatter: function specialname(value,row,index){
					return '<span class="inputname">'+value+'</span>';
				}
			},
			{
				field:'filesize',
				title:'File Size',
				align: 'center',
				valign: 'middle'
			},
			{
				field:'uploadtime',
				title:'Upload Time',
				align: 'center',
				valign: 'middle'
			},
			{
				field:'remove',
				title:'Remove',
				align: 'center',
				valign: 'middle',
				formatter: function (){
					return '<button class="btn btn-default btn-rm"><i class="glyphicon glyphicon-trash"></i> Delete</button>';
				},
				events: {
					'click .btn-rm': function (e, val, row) {
						removerow(row.fileid, row.filename, uid);
					}
				}
			},
		]
	});	
	//$("#stb").bootstrapTable('append',data);
	var toolbar = document.getElementsByClassName('fixed-table-toolbar');
	var cleatdiv = document.createElement('div');
	cleatdiv.setAttribute('class','pull-left');
	var cleatbtn = document.createElement('button');	
	cleatbtn.setAttribute('style','background-color:#8775a7;color:#ffffff;');
	cleatbtn.setAttribute('class','btn');
	cleatbtn.setAttribute('id','clear');
	cleatbtn.onclick=function(){$('#modeltable').bootstrapTable('removeAll');};
	cleatbtn.innerHTML='<span class="glyphicon glyphicon-trash"></span>&nbsp Clear';
	cleatdiv.appendChild(cleatbtn);
	toolbar[0].appendChild(cleatdiv);
}
